import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootReducer from './rootReducer.ts';
import rootSaga from './rootSaga.ts';
import { registerStore } from './accessor.ts';

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({ collapsed: true });

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false })
      .concat(sagaMiddleware)
      .concat(logger),
});

// Before the sagas run: they reach graphQLApi, which reports through the
// store. See accessor.ts for why this is a registration and not an import.
registerStore(store);

sagaMiddleware.run(rootSaga);

export default store;
